import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { StoreChangeDisclaimer } from 'features/store/pages/store-locator/components';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { DeliveryTerms } from 'components/address-modal/delivery-terms';

import { ButtonContainer, DeliveryInfoContainer, LoadingText } from './styled';

interface IDeliveryFormFooterProps {
  submitAddress: () => void;
  setCreateAddressView: (show: boolean) => void;
  showDeliveryAddresses: boolean;
  isDisabled: boolean;
  isLoading: boolean;
}

export const DeliveryAddressFormFooter: React.FC<React.PropsWithChildren<
  IDeliveryFormFooterProps
>> = ({ submitAddress, setCreateAddressView, showDeliveryAddresses, isDisabled, isLoading }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <DeliveryInfoContainer>
        <StoreChangeDisclaimer />
        <DeliveryTerms />
      </DeliveryInfoContainer>
      <Box alignItems="center">
        <ButtonContainer>
          <ActionButton
            onPress={submitAddress}
            fullWidth
            disabled={isLoading || isDisabled}
            isLoading={isLoading}
            testID="deliver-here"
            _text={{ fontSize: 'lg' }}
          >
            {formatMessage({ id: 'deliverHere' })}
          </ActionButton>
        </ButtonContainer>
        {showDeliveryAddresses && (
          <ButtonContainer>
            <ActionButton
              testID="back-to-saved-addresses"
              fullWidth
              variant={ActionButtonVariants.OUTLINE}
              onPress={() => setCreateAddressView(false)}
              _text={{ fontSize: 'md' }}
            >
              {formatMessage({ id: 'backToSavedAddresses' })}
            </ActionButton>
          </ButtonContainer>
        )}
      </Box>
      {isLoading && (
        <Box>
          <LoadingText>{formatMessage({ id: 'deliveryCheckingMessage' })}</LoadingText>
        </Box>
      )}
    </>
  );
};
